/* 0-100 - server errors */
export const CONNECTION_ERROR = 0;
export const GAME_NOT_FOUND = 7;
export const UNKNOWN_SERVER_ERROR = 100;
export const CONNECTION_LOST = 101;
export const NOT_ENOUGH_BALANCE = 102;
export const NOT_AUTHORIZED = 103;

export default { CONNECTION_ERROR, GAME_NOT_FOUND, UNKNOWN_SERVER_ERROR, CONNECTION_LOST, NOT_ENOUGH_BALANCE, NOT_AUTHORIZED };